import { useEffect, useState } from 'react';
import { DailyInsight } from '../../../interfaces/DailyInsights';
import { insightsWidgetService } from '../../../services/insightsWidgetService';
import { SolutionType } from '../../../../shared/constants/user-info/solutionType';

export const useDailyInsights = (solutionType: SolutionType) => {
  const [dailyInsight, setDailyInsight] = useState<DailyInsight | null>(null);

  const fetchDailyInsight = async () => {
    const insight = await insightsWidgetService.getDailyInsights(solutionType);
    setDailyInsight(insight);
  };

  useEffect(() => {
    fetchDailyInsight();
  }, [solutionType]);

  return dailyInsight;
};
